module.exports = __webpack_public_path__ + "static/media/29ADMSPC40.c595a68a.jpg";